import { render, staticRenderFns } from "./VideosTopic.vue?vue&type=template&id=75b10add&"
import script from "./VideosTopic.vue?vue&type=script&lang=ts&"
export * from "./VideosTopic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports